import { defineMessages } from 'react-intl';

export const messages: {
	cardMoreActions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	edit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	delete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteConfirmTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteConfirmBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	favoritePrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unfavoritePrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sharePrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectPrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardMoreActions: {
		id: 'rovo-conversation-actions.prompt-card.more-actions',
		defaultMessage: 'More actions',
		description: 'Accessible label for the more actions icon on a prompt card',
	},
	edit: {
		id: 'rovo-conversation-actions.prompt-card.edit',
		defaultMessage: 'Edit',
		description: 'Edit option in the prompt card dropdown menu',
	},
	duplicate: {
		id: 'rovo-conversation-actions.prompt-card.duplicate',
		defaultMessage: 'Duplicate',
		description: 'Duplicate option in the prompt card dropdown menu',
	},
	delete: {
		id: 'rovo-conversation-actions.prompt-card.delete',
		defaultMessage: 'Delete',
		description: 'Delete option in the prompt card dropdown menu',
	},
	deleteConfirmTitle: {
		id: 'rovo-conversation-actions.prompt-card.delete-confirm-title',
		defaultMessage: 'Delete this prompt?',
		description: 'Title for the delete prompt confirmation modal',
	},
	deleteConfirmBody: {
		id: 'rovo-conversation-actions.prompt-card.delete-confirm-body',
		defaultMessage: "Are you sure you want to delete this prompt? This action can't be undone.",
		description: 'Body text for the delete prompt confirmation modal',
	},
	cancel: {
		id: 'rovo-conversation-actions.prompt-card.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button in the delete confirmation modal',
	},
	favoritePrompt: {
		id: 'rovo-conversation-actions.prompt-card.favorite',
		defaultMessage: 'Add to favorites',
		description: 'Accessible label for favoriting a prompt',
	},
	unfavoritePrompt: {
		id: 'rovo-conversation-actions.prompt-card.unfavorite',
		defaultMessage: 'Remove from favorites',
		description: 'Accessible label for unfavoriting a prompt',
	},
	sharePrompt: {
		id: 'rovo-conversation-actions.prompt-card.share',
		defaultMessage: 'Share',
		description: 'Accessible label for sharing a prompt',
	},
	noResultsTitle: {
		id: 'rovo-conversation-actions.prompt-card.no-results-title',
		defaultMessage: 'No results found',
		description: 'Title displayed when no prompts match the selected filters',
	},
	noResultsSubtitle: {
		id: 'rovo-conversation-actions.prompt-card.no-results-subtitle',
		defaultMessage: 'Try removing your filters and searching again',
		description: 'Subtitle displayed when no prompts match the selected filters',
	},
	selectPrompt: {
		id: 'rovo-conversation-actions.prompt-card.select-prompt',
		defaultMessage: 'Select {title}',
		description: 'Accessible label for the multiselect checkbox on a prompt card',
	},
});
